import {
  isPlatformBrowser,
} from "@angular/common";
import {
  Directive,
  inject,
  OnInit,
  PLATFORM_ID,
  DOCUMENT,
} from "@angular/core";
import { environment } from "../../../../../../environments/environment";
import { eventThemeDefault } from "../../../../../constants/event-theme.constants";

@Directive({
    selector: "[lsAddClassEventTheme]",
    standalone: true,
})

export class AddClassEventThemeDirective implements OnInit {
    public eventTheme: string = environment.eventTheme;
    public minioUrl: string = environment.minioUrl;

    private readonly platformId: Object = inject(PLATFORM_ID);
    private readonly document: Document = inject(DOCUMENT);

    public ngOnInit(): void {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }

        if (this.eventTheme !== eventThemeDefault) {
            this.document.body.classList.add(this.eventTheme);

            const buttonBgSettings: string = "repeat-x bottom left / auto 100%";

            this.document.documentElement.style.setProperty(
                "--ls-event-theme-btn-primary-bg",
                `url(${this.minioUrl}event-themes/${this.eventTheme}/images/btn-primary-bg.svg) ${buttonBgSettings}`,
            );
        }
    }
}
